<template>
  <div class="card">
    <div class="card-body">
      <router-link
        class="close"
        :to="'/' + 'products/' + $i18n.locale"
      ></router-link>
      <h5 class="create-title">{{ $t('addNewExp') }}</h5>
      <form @submit.prevent="createProduct">
        <div>
          <p class="inputLabel">{{ $t('experienceName') }}</p>
          <input
            v-model="product.name"
            class="field"
            type="text"
            maxlength="18"
            :placeholder="$t('expNameExample')"
            :class="{ 'error-boarder': $v.product.name.$error }"
            @blur="$v.product.name.$touch()"
          />
          <!--Form validation-->
          <template v-if="$v.product.name.$error">
            <p v-if="!$v.product.name.required" class="errorMessage">
              {{ $t('prodNameReq') }}
            </p>
          </template>
          <multiselect
            v-model="product.prodCat"
            :options="categoryNames"
            :searchable="false"
            :close-on-select="true"
            track-by="id"
            label="name"
            :placeholder="$t('selectExpCat')"
            :show-labels="false"
            @select="nameSelect"
            :class="{ 'error-boarder': $v.product.prodCat.$error }"
            @input="$v.product.prodCat.$touch()"
          ></multiselect>
          <br />
        </div>
        <!--Form validation-->
        <template v-if="$v.product.prodCat.$error">
          <p v-if="!$v.product.prodCat.required" class="errorMessage">
            {{ $t('prodCatReq') }}
          </p>
        </template>

        <multiselect
          v-model="product.supplier"
          :options="supplierNames"
          :searchable="true"
          :close-on-select="true"
          track-by="id"
          label="name"
          :placeholder="$t('selectExpSupplier')"
          :show-labels="false"
          @select="nameSelect"
          :class="{ 'error-boarder': $v.product.supplier.$error }"
          @input="$v.product.supplier.$touch()"
        ></multiselect>
        <br />

        <!--Form validation-->
        <template v-if="$v.product.supplier.$error">
          <p v-if="!$v.product.supplier.required" class="errorMessage">
            {{ $t('supplierReq') }}
          </p>
        </template>

        <b-form-textarea
          class="field form-control"
          aria-label="With textarea"
          v-model="product.description"
          maxlength="300"
          type="text"
          :placeholder="$t('expDesc50')"
          :class="{ 'error-boarder': $v.product.description.$error }"
          rows="4"
          @blur="$v.product.description.$touch()"
        ></b-form-textarea>
        <!--Form validation-->
        <template v-if="$v.product.description.$error">
          <p v-if="!$v.product.description.required" class="errorMessage">
            {{ $t('expDescReq') }}
          </p>
        </template>

        <input
          class="field"
          v-model="product.priceMin"
          type="number"
          min="0"
          step=".01"
          :placeholder="$t('priceMin')"
          :class="{ 'error-boarder': $v.product.priceMin.$error }"
          @blur="$v.product.priceMin.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.product.priceMin.$error">
          <p v-if="!$v.product.priceMin.required" class="errorMessage">
            {{ $t('priceMinReq') }}
          </p>
        </template>

        <input
          class="field"
          v-model="product.priceMax"
          type="number"
          min="0"
          step=".01"
          :placeholder="$t('priceMax')"
          :class="{ 'error-boarder': $v.product.priceMax.$error }"
          @blur="$v.product.priceMax.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.product.priceMax.$error">
          <p v-if="!$v.product.priceMax.required" class="errorMessage">
            {{ $t('priceMaxReq') }}
          </p>
        </template>
        <BaseInput
          v-model="product.urlReservation"
          type="text"
          :placeholder="$t('url?')"
          :class="{ 'error-boarder': $v.product.urlReservation.$error }"
          @blur="$v.product.urlReservation.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.product.urlReservation.$error">
          <p v-if="!$v.product.urlReservation.required" class="errorMessage">
            {{ $t('urlResReq') }}
          </p>
        </template>
        <template v-if="$v.product.urlReservation.$error">
          <p v-if="!$v.product.urlReservation.url" class="errorMessage">
            {{ $t('validUrlReq') }}
          </p>
        </template>

        <button
          class="add-btn"
          type="submit"
          buttonClass="-fill-gradient"
          :disabled="$v.$invalid"
        >
          {{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
      <sweet-modal icon="success" ref="modalSuccess">
        {{ $t('addedExpConf') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalError">
        {{ $t('errorMsg') }}
        <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NProgress from 'nprogress'
import { required, url } from 'vuelidate/lib/validators'

export default {
  name: 'productCreate',
  data() {
    return {
      categoryNames: [],
      categoryName: [],
      supplierNames: [],
      supplierName: [],
      supplier: [],
      prodCat: [],
      product: this.createFreshProductObject(),
      selectedFile: null,
      widget: null,
    }
  },
  validations: {
    product: {
      name: { required },
      prodCat: { required },
      supplier: { required },
      description: { required },
      priceMin: { required },
      priceMax: { required },
      urlReservation: { required, url },
    },
  },
  mounted() {
    axios
      .all([
        axios.get(`${process.env.VUE_APP_API_URL}/experienceCategories`),
        axios.get(`${process.env.VUE_APP_API_URL}/suppliers`),
      ])
      .then(
        axios.spread((productCategoriesRes, suppliersRes) => {
          ;(this.categoryNames = productCategoriesRes.data),
            (this.supplierNames = suppliersRes.data)
        })
      )
  },
  methods: {
    async createProduct() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch(
            'experience/upsertExperience',
            this.generateExpereinceJson()
          )
          .then((response) => {
            if (response.message) {
              alert(response.message)
            } else {
              // this.$refs.imageUpload.onSubmit(response.insertId)
              // this.$router.push({ name: 'product', params: {productId: response.insertId} }) // automatically redirect to login when user click "register"//
              NProgress.done()
              this.product = this.createFreshProductObject()
            }
          })
          .catch(() => {
            this.$refs.modalError.open()
            NProgress.done()
          })
      }
    },
    generateExpereinceJson() {
      const experience = {
        supplier_id: this.product.supplier.id,
        client_id: this.product.client_id,
        expCat_id: this.product.prodCat.id,
        name: this.product.name,
        description: this.product.description,
        price_min: this.product.priceMin,
        price_max: this.product.priceMax,
        url: this.product.urlReservation,
      }
      return experience
    },
    createFreshProductObject() {
      const client = this.$store.state.client.client
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        supplier: '',
        client_id: client,
        prodCat: '',
        name: '',
        description: '',
        priceMin: '',
        priceMax: '',
        urlReservation: '',
      }
    },
    nameSelect(option) {
      this.categoryNames.name = option.name
      this.supplierNames.name = option.name
    },
  },
}
</script>

<style scoped>
@import '../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
.field {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
  background: rgb(252, 250, 250);
}

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 60px 30px 60px;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  margin-top: 1em;
  color: var(--bg);
}

.error-boarder {
  border: 2px solid var(--primaryDark);
}

form {
  width: 45%;
}

button.action:hover {
    opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}

.inputLabel {
  text-align: left;
  margin-bottom: 0px;
}

.bgOptional {
  background: rgb(252, 250, 250);
  border: none !important;
}

.create-title {
  font-weight: 600;
  font-size: 2.5em;
  margin-top: 20px;
}

.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.add-btn {
	margin-top: 1em;
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.5em;
	letter-spacing: 3px;
	width: 80%;
	border-radius: 5px;
	text-transform: uppercase;
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}
@media screen and (min-width: 560px) {
  .close {
    display: none;
  }
}

textarea.form-control {
  width: 100%;
  height: auto !important;
}

@media screen and (max-width: 560px) {
  .field {
    margin-bottom: 15px;
  }

  textarea.form-control {
    width: 100%;
    height: auto !important;
  }
  form {
    width: 100%;
    padding: 10px;
  }
  .optionalData {
    padding: 0 20px 10px 20px;
  }
  .create-title {
  font-size: 1.8em;
  margin-top: 60px;
  margin-bottom: 20px;
}
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}
</style>

<style>
/* global styles */
.pac-container {
  z-index: 1042 !important;
}
</style>
